<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import BuildingCreate from '../../../../buildings/components/BuildingCreate.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
    }
})
</script>

<template>
  <BuildingCreate />
</template>